<template>
    <div>
        <el-date-picker
            v-if="mode === 'edit'"
            v-bind="datePickerOptions"
            :ref="reference"
            v-model="currentValue"
            valueFormat="x"
            type="date"
            format="DD/MM/YYYY"
            :placeholder="$t.__('common.labels.date')"
            @change="update"
        >
        </el-date-picker>
        <p v-else>
            {{ date }}
        </p>
    </div>
</template>

<script>
import CfMixin from '../../../mixins/CustomfieldInputsMixins';

export default {
    mixins: [CfMixin],
    emits: ['update:modelValue'],
    data() {
        return {
            localValue: this.value,
            currentValue: '',
            datePickerOptions: {
                disabledDate: this.limitDate,
                firstDayOfWeek: 1,
            },
        };
    },

    computed: {
        date() {
            if (this.currentValue) {
                return moment(this.currentValue).format('LL');
            } else {
                return this.$l10n.__('N/C');
            }
        },
    },
    watch: {
        value: {
            handler: function (newValue) {
                this.localValue = newValue;
                this.currentValue = newValue.timestampValue ? newValue.timestampValue * 1000 : null;
            },
            deep: true,
        },
    },

    created() {
        if (!this.localValue) {
            this.localValue = this.templateData;
        } else {
            this.currentValue = this.value.timestampValue * 1000;
        }
    },
    methods: {
        checkParams(newValue) {
            let valid = true;
            valid = this.checkMinMaxParams(newValue / 1000);
            return valid;
        },

        update(newValue) {
            if (newValue === null) {
                this.$emit('update:modelValue', { ...this.localValue, ['timestampValue']: null });
            } else {
                if (this.checkParams(newValue)) {
                    this.$emit('update:modelValue', {
                        ...this.localValue,
                        ['timestampValue']: newValue / 1000,
                    });
                }
            }
        },

        limitDate(date) {
            var result;

            if (this.prop.min && date < new Date(this.prop.min * 1000)) {
                result = true;
            } else if (this.prop.max && date > new Date(this.prop.max * 1000)) {
                result = true;
            } else return false;

            return result;
        },
    },
};
</script>
